import {
  GET_FOOD_CONFIG_REQUEST,
  GET_FOOD_CONFIG_SUCCESS,
  GET_FOOD_CONFIG_FAILURE,
  UPDATE_FOOD_CONFIG_REQUEST,
  UPDATE_FOOD_CONFIG_SUCCESS,
  UPDATE_FOOD_CONFIG_FAILURE,
} from "./actionType";
import { getFoodConfig, updateFoodConfig } from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";

// ── Get Food Config ─────────────────────────────────────────────────────────
const getFoodConfigAction = () => (dispatch) => {
  dispatch({ type: GET_FOOD_CONFIG_REQUEST });
  getFoodConfig()
    .then((res) => {
      let { status, resData } = ResponseFilter(res);
      if (status) {
        dispatch({ type: GET_FOOD_CONFIG_SUCCESS, payload: resData });
      } else {
        dispatch({ type: GET_FOOD_CONFIG_FAILURE, payload: res.data });
      }
    })
    .catch((err) => dispatch({ type: GET_FOOD_CONFIG_FAILURE, payload: err }));
};

// ── Update Food Config ───────────────────────────────────────────────────────
const updateFoodConfigAction = (params) => (dispatch) => {
  dispatch({ type: UPDATE_FOOD_CONFIG_REQUEST });
  return updateFoodConfig(params)
    .then((res) => {
      let { status, resData } = ResponseFilter(res);
      if (status) {
        dispatch({ type: UPDATE_FOOD_CONFIG_SUCCESS, payload: resData });
        return { success: true };
      } else {
        dispatch({ type: UPDATE_FOOD_CONFIG_FAILURE, payload: res.data });
        return { success: false };
      }
    })
    .catch((err) => {
      dispatch({ type: UPDATE_FOOD_CONFIG_FAILURE, payload: err });
      return { success: false };
    });
};

export { getFoodConfigAction, updateFoodConfigAction };
